declare const require: any;

export const environment = {
  production: false,
  civChatKey: '',
  civChatScriptUrl: 'https://elham.user.com/widget.js',
  apiUrl: 'https://live-test-api.elhamsol.com/api/v1',
  mock: true,
  version: require('../../package.json').version,
  localDomainForTesting: '192.168.8.100',
  GA_TRACKING_ID: 'UA-114747915-22',
  GA_TRACKING_LEGACY: 'UA-114747915-22',
  spaceId:'vbviia7ha5eh',
  accessToken:'Voy9bgOYeb6w-ixEkB88BhU4rQD-oOhJb6TB59h6aPk',
};
